/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Navtitles_Poweredbyveganame4Inputs */

const en_navtitles_poweredbyveganame4 = /** @type {(inputs: Navtitles_Poweredbyveganame4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vega`)
};

/**
* | output |
* | --- |
* | "Vega" |
*
* @param {Navtitles_Poweredbyveganame4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const navtitles_poweredbyveganame4 = /** @type {((inputs?: Navtitles_Poweredbyveganame4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Navtitles_Poweredbyveganame4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_navtitles_poweredbyveganame4(inputs)
});
export { navtitles_poweredbyveganame4 as "navTitles_poweredByVegaName" }